// VALUES
export const MODULAR_CONFIG_UPLOAD_ALERT_WIDTH = 520;
export const MODULAR_CONFIG_UPLOAD_DIALOG_WIDTH = 600;
export const MODULAR_CONFIG_UPLOAD_ALERT_HEIGHT = 400;

// LAYOUT
export const USERS_TAB_TEXT = () => 'Users';
export const INTEGRATIONS_TAB_TEXT = () => 'Integrations';
export const SCRIPT_LOGS_TAB_TEXT = () => 'Script Logs';
export const TABLES_TAB_TEXT = () => 'Tables';
export const ROLES_TAB_TEXT = () => 'Roles';
export const STATIC_DOCS_TAB_TEXT = () => 'Static Documents';
export const RESOURCE_GROUPS_TAB_TEXT = () => 'Resource Groups';
export const TENANTS_DROPDOWN_LABEL = () => 'TENANTS';
export const NO_TENANTS_TEXT = () => 'No tenants found';
export const FEEDBACK_TEXT = () => 'Feedback?';
export const FEEDBACK_LINK = () => 'https://forms.gle/qfdUJkLjrYDJpV6B6';

// ADMIN ACCOUNT PAGE
export const NAME_LABEL = () => 'Name';
export const TIME_CREATED_LABEL = () => 'Created';
export const PASSWORD_HIDDEN_TEXT = () => '**************';
export const ACCOUNT_BUTTON_LABEL = () => 'Account';

// HEADER
export const SWITCH_ROLES_BUTTON_LABEL = () => 'Switch Roles and Logout';
export const LOGOUT_ACTION_TEXT = () => 'Logout';
export const LOGOUT_CONTINUE_ACTION_TEXT = () => 'Continue';
export const LOGOUT_CONFIRM_ACTION_TEXT = () => 'Confirm Logout';
export const LOGOUT_CONFIRM_INFO_TEXT = () =>
	'Are you sure you want to logout?';

// USERS
export const USERS_HEADER = () => 'Users';
export const USERS_TABLE_USERNAME_HEADER = () => 'Username';
export const USERS_TABLE_PERMISSIONS_HEADER = () => 'Permissions';
export const USERS_TABLE_ROLES_HEADER = () => 'Roles';
export const USERS_TABLE_NAME_HEADER = () => 'Full Name';
export const USERS_TABLE_EMAIL_HEADER = () => 'Email';
export const USERS_TABLE_STATUS_HEADER = () => 'Status';
export const USERS_TABLE_CREATED_HEADER = () => 'Created';
export const USERS_TABLE_ACTIONS_HEADER = () => 'Actions';
export const USERS_TABLE_NO_USERS_FOUND_TEXT = () => 'No users found';
export const USERS_NEW_USER_DIALOG_TITLE = () => 'New User';
export const USERS_EDIT_USER_DIALOG_TITLE = () => 'Edit User';
export const USERS_FORM_USERNAME_LABEL = () => 'Username';
export const USERS_FORM_PERMISSIONS_LABEL = () => 'Permissions';
export const USERS_FORM_ROLES_LABEL = () => 'Roles';
export const USERS_FORM_NO_ROLES_LABEL = () => 'No Roles Assigned';
export const USERS_FORM_MIGRATION_PENDING_LABEL = () =>
	' Role Migration Pending';
export const USERS_FORM_NAME_LABEL = () => 'Full Name';
export const USERS_FORM_EMAIL_LABEL = () => 'Email';
export const USERS_FORM_PASSWORD_LABEL = () => 'Password';
export const USERS_FORM_ADD_BUTTON_LABEL = () => 'Create';
export const USERS_FORM_EDIT_BUTTON_LABEL = () => 'Save';
export const USERS_FORM_CANCEL_BUTTON_LABEL = () => 'Cancel';
export const USER_MODAL_ADD_USER_TITLE = () => 'New User';
export const USER_MODAL_EDIT_USER_TITLE = () => 'Edit User';
export const USER_MODAL_CANCEL_BUTTON_TEXT = () => 'Cancel';
export const USER_MODAL_ADD_USER_BUTTON_TEXT = () => 'Create User';
export const USER_MODAL_EDIT_USER_BUTTON_TEXT = () => 'Edit User';
export const USER_MODAL_ENABLE_USER_BUTTON_TEXT = () => 'Enable User';
export const USER_MODAL_DISABLE_USER_BUTTON_TEXT = () => 'Disable User';
export const OPTIONAL_TEXT = () => 'Optional';
export const USERS_TITLE_TEXT = () => 'Users';
export const USERS_NEW_USER_BUTTON_TEXT = () => 'New User';
export const TABLE_NO_USERS_FOUND_TEXT = () => 'No users found';
export const EMPTY_TABLE_LABEL = () => 'N/A';
export const ERROR_MESSAGE = () => 'Error';
export const ENABLED_USER_TEXT = () => 'Enabled';
export const DISABLED_USER_TEXT = () => 'Disabled';
export const PERMANENT_LABEL = () => 'This cannot be changed';
export const INVALID_EMAIL_TEXT = () => 'Invalid email';
export const INVALID_NAME_TEXT = () => 'Invalid name';
export const INVALID_USERNAME_TEXT = () => 'Invalid username';
export const INVALID_USERNAME_LENGTH_TEXT = () =>
	'Username must be at least 6 characters';
export const INVALID_PASSWORD_TEXT = () => 'Password cannot be empty';
export const INVALID_PERMISSIONS_TEXT = () => 'Invalid Permissions';
export const NEW_USER_DIALOG_TITLE = () => 'New User';
export const USERS_PAGE_SSO_HELPER_TEXT_1 = () =>
	'To add or remove a user from this list, visit the ';
export const USERS_PAGE_SSO_HELPER_TEXT_2 = () => ' page.';

// SCRIPT LOGS
export const SCRIPT_LOGS_HEADER = () => 'Script Logs';
export const SCRIPT_LOGS_SUBHEADER_TIMESTAMP = () => 'Timestamp';
export const SCRIPT_LOGS_SUBHEADER = () => 'Message';
export const SCRIPT_LOGS_PLUGIN_SUBHEADER = () => 'Message';
export const SCRIPT_LOGS_NO_LOGS_FOUND_TEXT = () => 'No script logs found';
export const SCRIPT_LOGS_LOAD_MORE_TEXT = () => 'Load Additional Logs';
export const SCRIPT_LOGS_SEARCH_INPUT_LABEL = () => 'Search';
export const SCRIPT_LOGS_START_DATE_INPUT_LABEL = () => 'Start Date';
export const SCRIPT_LOGS_DATE_FORMAT = () => 'yyyy/MM/dd HH:mm:ss';
export const SCRIPT_LOGS_END_DATE_INPUT_LABEL = () => 'End Date';
export const SCRIPT_LOGS_SEARCH_BUTTON_LABEL = () => 'Apply Filters';
export const SCRIPT_LOGS_CLEAR_BUTTON_LABEL = () => 'Reset';
export const SCRIPT_LOGS_NESTED_HEADER = () => 'Plugin Logs';
export const SCRIPT_LOGS_NESTED_CLOSE_TEXT = () => 'Close';
export const SCRIPT_LOGS_ROW_DATE_FORMAT = () => 'MMMM D, YYYY h:mm:ss A';
export const SCRIPT_LOGS_PLUGIN_ROW_DATE_FORMAT = () => 'LTS';
export const SCRIPT_LOGS_FETCH_MORE_TEXT = () => 'Loading more...';
export const SCRIPT_LOGS_HAS_MORE_TEXT = () => 'Load More';
export const SCRIPT_LOGS_NO_MORE_TEXT = () => 'End of logs';
export const SCRIPT_LOGS_REFRESH_BUTTON_LABEL = () => 'Refresh';
export const SCRIPT_LOGS_REFRESHING_LABEL = () => 'Refreshing...';
export const SCRIPT_LOGS_LAST_UPDATED_LABEL = () => 'Last Updated: ';

// TABLES
export const TABLES_HEADER = () => 'Tables';
export const TABLES_SUBHEADER_TABLE_NAME = () => 'Table Name';
export const TABLES_SUBHEADER_EFFECTIVE_DATE = () => 'Effective Date';
export const TABLES_SUBHEADER_ACTIONS = () => 'Actions';
export const TABLES_PLUGIN_SUBHEADER = () => 'Message';
export const TABLES_NO_LOGS_FOUND_TEXT = () => 'No tables found';
export const TABLES_LOAD_MORE_TEXT = () => 'Load Additional Tables';
export const TABLES_SEARCH_INPUT_LABEL = () => 'Table name';
export const TABLES_START_DATE_INPUT_LABEL = () => 'As of date';
export const TABLES_DATE_FORMAT = () => 'yyyy/MM/dd HH:mm:ss';
export const TABLES_END_DATE_INPUT_LABEL = () => 'End Date';
export const TABLES_SEARCH_BUTTON_LABEL = () => 'Apply Filters';
export const TABLES_CLEAR_BUTTON_LABEL = () => 'Reset';
export const TABLES_NESTED_HEADER = () => 'Plugin Logs';
export const TABLES_NESTED_CLOSE_TEXT = () => 'Close';
export const TABLES_ROW_DATE_FORMAT = () => 'MMMM D, YYYY h:mm:ss A';
export const TABLES_PLUGIN_ROW_DATE_FORMAT = () => 'LTS';
export const TABLES_FETCH_MORE_TEXT = () => 'Loading more...';
export const TABLES_HAS_MORE_TEXT = () => 'Load More';
export const TABLES_NO_MORE_TEXT = () => 'End of logs';
export const TABLES_REFRESH_BUTTON_LABEL = () => 'Refresh';
export const TABLES_REFRESHING_LABEL = () => 'Refreshing...';
export const TABLES_LAST_UPDATED_LABEL = () => 'Last Updated: ';
export const TABLES_HELPER_TEXT = () =>
	'The tables shown here are managed separately from those defined in Config.zip.';

// TABLES FORM
export const TABLES_MODAL_HEADER = () => 'Upload Table';
export const TABLES_MODAL_TABLE_NAME_FIELD = () => 'Table Name';
export const TABLES_MODAL_EFFECTIVE_DATE_FIELD = () => 'Effective Date';
export const TABLES_MODAL_LOADING_MESSAGE = () => 'Uploading...';
export const TABLES_MODAL_FILE_TYPE_FIELD = () => 'File Type';
export const TABLES_MODAL_FILE_FIELD = () => 'Select File';
export const TABLES_MODAL_SUBMIT_BUTTON = () => 'Upload';
export const TABLES_MODAL_CANCEL_BUTTON = () => 'Cancel';
export const TABLES_MODAL_UPLOAD_MORE_BUTTON = () => 'Upload More';
export const TABLES_MODAL_FINISHED_BUTTON = () => 'Done';
export const TABLES_MODAL_SUCCESS_MESSAGE = (plural: boolean) =>
	plural ? ' tables uploaded successfully!' : ' table uploaded successfully!';
export const TABLES_MODAL_FAILURE_MESSAGE = (plural: boolean) =>
	plural ? ' tables failed to upload.' : ' table failed to upload.';
export const TABLES_ACTIONS_DOWNLOAD_TOOLTIP_TEXT = () => 'Download table';
export const TABLES_ACTIONS_DELETE_TOOLTIP_TEXT = () => 'Delete table';

export const TABLES_CONFIRM_DELETE_MODAL_HEADER = () => 'Delete Table';
export const TABLES_CONFIRM_DELETE_MODAL_MESSAGE = (tableName: string) =>
	`Are you sure you want to delete the table ${tableName}?`;
export const TABLES_CONFIRM_DELETE_MODAL_CANCEL_BUTTON = () => 'Cancel';
export const TABLES_CONFIRM_DELETE_MODAL_DELETE_BUTTON = () => 'Delete';

// DATE COMPLIANCE
export const DATE_COMPLIANCE_HEADER = () => 'Resource Groups';
export const DATE_COMPLIANCE_TIMESTAMPS_LIST_HEADER = () => 'Effective dates';
export const DATE_COMPLIANCE_TIMESTAMPS_PRODUCT_LABEL = () => 'Product';
export const DATE_COMPLIANCE_ADD_BUTTON_TEXT = () => 'Create New';
export const DATE_COMPLIANCE_SUBHEADER = () =>
	'Manage your configuration resources (effective-dated tables, static documents, and document & formula templates) here.';
export const DATE_COMPLIANCE_SUBHEADER_2 = () =>
	'The files shown here are managed outside of Config.zip and take precedence over those within it.';
export const DATE_COMPLIANCE_PRODUCT_LABEL = () => 'Select product';
export const DATE_COMPLIANCE_EFFECTIVE_DATE_FIELD = () => 'Effective Date';
export const DATE_COMPLIANCE_CANCEL_BUTTON = () => 'Cancel';
export const DATE_COMPLIANCE_SUBMIT_BUTTON = () => 'Upload';
export const DATE_COMPLIANCE_FINISHED_BUTTON = () => 'Done';
export const DATE_COMPLIANCE_UPLOADING_MESSAGE = () => 'Uploading...';
export const DATE_COMPLIANCE_LOADING_MESSAGE = () => 'Loading resources...';
export const DATE_COMPLIANCE_EMPTY_ZIP_MESSAGE = () =>
	'The uploaded ZIP file appears to be empty. Please make sure the ZIP file contains the necessary files and try again.';
export const DATE_COMPLIANCE_SUCCESS_MESSAGE = (plural: boolean) =>
	plural
		? ' resources uploaded successfully!'
		: ' resource uploaded successfully!';
export const DATE_COMPLIANCE_FAILURE_MESSAGE = (plural: boolean) =>
	plural ? ' resources failed to upload.' : ' resource failed to upload.';

export const DATE_COMPLIANCE_CREATE_MODAL_TOOLTIP = () =>
	`Files may be uploaded individually, in multiples of a particular type, or in multiples of a variety of types - refer to the documentation for further information. If the same filename already exists within a group, it will be overwritten when a new upload is made.`;
export const DATE_COMPLIANCE_SINGLE_FILE_UPLOAD = () => 'Single File Type';
export const DATE_COMPLIANCE_SINGLE_FILE_INFO_MESSAGE = () =>
	'Upload a single or zip archive of multiple files of the desired type.';
export const DATE_COMPLIANCE_BULK_UPLOAD = () => 'Multiple File Types';
export const DATE_COMPLIANCE_BULK_INFO_MESSAGE = () =>
	'Upload a zip archive of the various resource file types desired. Refer to documentation for details on required directory structure.';
export const DATE_COMPLIANCE_TYPE_TABLE = (plural?: boolean) =>
	plural ? 'Tables' : 'Table';
export const DATE_COMPLIANCE_TYPE_STATIC_DOC = (plural?: boolean) =>
	plural ? 'Static Documents' : 'Static Document';
export const DATE_COMPLIANCE_TYPE_DOCUMENT_TEMPLATE = (plural?: boolean) =>
	plural ? 'Document Templates' : 'Document Template';
export const DATE_COMPLIANCE_TYPE_FORMULA_TEMPLATE = (plural?: boolean) =>
	plural ? 'Formula Templates' : 'Formula Template';

export const DATE_COMPLIANCE_CONFIRM_DELETE_MODAL_HEADER = (
	resourceType: string,
) => `Delete ${resourceType}`;
export const DATE_COMPLIANCE_CONFIRM_DELETE_MODAL_MESSAGE = (
	documentName: string,
	resourceType: string,
) =>
	`Are you sure you want to delete the ${resourceType.toLowerCase()} ${documentName}?`;

export const DATE_COMPLIANCE_CONFIRM_DELETE_MODAL_CANCEL_BUTTON = () =>
	'Cancel';
export const DATE_COMPLIANCE_CONFIRM_DELETE_MODAL_DELETE_BUTTON = () =>
	'Delete';
export const DATE_COMPLIANCE_ROW_DATE_FORMAT = () => 'MMMM D, YYYY h:mm:ss A';
export const DATE_COMPLIANCE_ADD_MORE_FILES = () => 'Add more files';
export const DATE_COMPLIANCE_SEARCH_FILES = () => 'Search...';
export const DATE_COMPLIANCE_SEARCH_NO_RESULTS = (
	resourceType: string,
	query: string,
) => `No ${resourceType} found matching the search criteria: ${query}.`;
export const DATE_COMPLIANCE_NO_RESOURCES_FOUND_FILES = (
	resourceType: string,
	date: string,
) => `No ${resourceType} have been uploaded for the effective date: ${date}.`;

export const DATE_COMPLIANCE_FAILED_TO_FETCH_RESOURCES = (
	resourceType: string,
	error: any,
) => `Error fetching ${resourceType} resources: ${error}.`;

// STATIC DOCS
export const STATIC_DOCS_HEADER = () => 'Static Documents';
export const STATIC_DOCS_SUBHEADER_FILE_NAME = () => 'Document Name';
export const STATIC_DOCS_SUBHEADER_EFFECTIVE_DATE = () => 'Effective Date';
export const STATIC_DOCS_SUBHEADER_ACTIONS = () => 'Actions';
export const STATIC_DOCS_PLUGIN_SUBHEADER = () => 'Message';
export const STATIC_DOCS_NO_LOGS_FOUND_TEXT = () => 'No script logs found';
export const STATIC_DOCS_LOAD_MORE_TEXT = () => 'Load Additional Logs';
export const STATIC_DOCS_SEARCH_INPUT_LABEL = () => 'Document name';
export const STATIC_DOCS_START_DATE_INPUT_LABEL = () => 'As of date';
export const STATIC_DOCS_DATE_FORMAT = () => 'yyyy/MM/dd HH:mm:ss';
export const STATIC_DOCS_END_DATE_INPUT_LABEL = () => 'End Date';
export const STATIC_DOCS_SEARCH_BUTTON_LABEL = () => 'Apply Filters';
export const STATIC_DOCS_CLEAR_BUTTON_LABEL = () => 'Reset';
export const STATIC_DOCS_NESTED_HEADER = () => 'Plugin Logs';
export const STATIC_DOCS_NESTED_CLOSE_TEXT = () => 'Close';
export const STATIC_DOCS_ROW_DATE_FORMAT = () => 'MMMM D, YYYY h:mm:ss A';
export const STATIC_DOCS_PLUGIN_ROW_DATE_FORMAT = () => 'LTS';
export const STATIC_DOCS_FETCH_MORE_TEXT = () => 'Loading more...';
export const STATIC_DOCS_HAS_MORE_TEXT = () => 'Load More';
export const STATIC_DOCS_NO_MORE_TEXT = () => 'End of logs';
export const STATIC_DOCS_REFRESH_BUTTON_LABEL = () => 'Refresh';
export const STATIC_DOCS_REFRESHING_LABEL = () => 'Refreshing...';
export const STATIC_DOCS_LAST_UPDATED_LABEL = () => 'Last Updated: ';
export const STATIC_DOCS_HELPER_TEXT = () =>
	'The static documents shown here are managed separately from those defined in Config.zip.';

// STATIC DOCS FORM
export const STATIC_DOCS_MODAL_HEADER = () => 'Upload Static Document';
export const STATIC_DOCS_MODAL_FILE_NAME_FIELD = () => 'Document Name';
export const STATIC_DOCS_MODAL_EFFECTIVE_DATE_FIELD = () => 'Effective Date';
export const STATIC_DOCS_MODAL_LOADING_MESSAGE = () => 'Uploading...';
export const STATIC_DOCS_MODAL_FILE_TYPE_FIELD = () => 'File Type';
export const STATIC_DOCS_MODAL_FILE_FIELD = () => 'Select File';
export const STATIC_DOCS_MODAL_SUBMIT_BUTTON = () => 'Upload';
export const STATIC_DOCS_MODAL_CANCEL_BUTTON = () => 'Cancel';
export const STATIC_DOCS_MODAL_UPLOAD_MORE_BUTTON = () => 'Upload More';
export const STATIC_DOCS_MODAL_FINISHED_BUTTON = () => 'Done';
export const STATIC_DOCS_MODAL_SUCCESS_MESSAGE = (plural: boolean) =>
	plural
		? ' documents uploaded successfully!'
		: ' document uploaded successfully!';
export const STATIC_DOCS_MODAL_FAILURE_MESSAGE = (plural: boolean) =>
	plural ? ' documents failed to upload.' : ' document failed to upload.';
export const STATIC_DOCS_ACTIONS_DOWNLOAD_TOOLTIP_TEXT = () =>
	'Download document';
export const STATIC_DOCS_ACTIONS_DELETE_TOOLTIP_TEXT = () =>
	'Delete static document';
export const STATIC_DOCS_CONFIRM_DELETE_MODAL_HEADER = () =>
	'Delete Static Document';
export const STATIC_DOCS_CONFIRM_DELETE_MODAL_MESSAGE = (
	documentName: string,
) => `Are you sure you want to delete the static document ${documentName}?`;
export const STATIC_DOCS_CONFIRM_DELETE_MODAL_CANCEL_BUTTON = () => 'Cancel';
export const STATIC_DOCS_CONFIRM_DELETE_MODAL_DELETE_BUTTON = () => 'Delete';
export const STATIC_DOCS_DELETE_SUCCESS_MESSAGE = () => 'Document deleted';
export const STATIC_DOCS_DELETE_FAILURE_MESSAGE = (error?: string) =>
	`Error deleting document${error ? `: ${error}` : ''}`;
export const STATIC_DOCS_UPLOAD_FAILURE_MESSAGE = (error?: string) =>
	`Error uploading document${error ? `: ${error}` : ''}`;

// MANAGE INTEGRATIONS
export const MANAGE_INTEGRATIONS_HEADER = () => 'Manage Integrations';
export const EXTERNAL_RATER_LABEL = (plural?: boolean) =>
	`External Rater${plural ? 's' : ''}`;
export const DATA_AUTOFILL_LABEL = (plural?: boolean) =>
	`Data Autofill${plural ? 's' : ''}`;
export const DATA_AUTOFILL_INTEGRATION_LABEL = (plural?: boolean) =>
	`Autofill Integration${plural ? 's' : ''}`;
export const AUTOFILL_SEQUENCE_LABEL = (plural?: boolean) =>
	`Autofill Sequence${plural ? 's' : ''}`;
export const AUTOFILL_LABEL = () => 'Autofill';
export const WEBHOOK_INTEGRATION_LABEL = () => 'Webhook Integration';
export const WEBHOOK_LABEL = (plural?: boolean) =>
	`Webhook${plural ? 's' : ''}`;
export const EXTERNAL_RATER_TYPE = () => 'external_rater';
export const DATA_AUTOFILL_TYPE = () => 'data_autofill';
export const WEBHOOK_TYPE = () => 'webhook';
export const ADD_LABEL = (itemType: () => string) => `Add ${itemType()}`;
export const NEW_LABEL = (itemType: () => string) => `New ${itemType()}`;
export const EDIT_LABEL = (itemType: () => string) => `Edit ${itemType()}`;
export const DELETE_LABEL = (itemType: () => string) => `Delete ${itemType()}`;
export const DELETE_CONFIRM_LABEL = (itemName: string) =>
	`Are you sure you want to delete ${itemName}?`;
export const DELETE_CONFIRM_MESSAGE = () => 'This action cannot be undone.';
export const INTEGRATION_DELETE_ACTION_TEXT = () => 'Yes, delete';
export const INTEGRATION_DELETE_CANCEL_TEXT = () => 'No, cancel';

export const INTEGRATION_HEADER_LABEL = (plural?: boolean) =>
	`Header${plural ? 's' : ''}`;
export const HEADER_VALUE_LABEL = () => 'Value';
export const INTEGRATION_NAME_LABEL = () => 'Name';
export const INTEGRATION_URL_LABEL = () => 'URL';
export const INTEGRATION_SECURITY_SPEC_INFO_MSG = () =>
	'Learn more about security features';
export const INTEGRATION_SECURITY_SPEC_SECRET_LABEL = () => 'Secret';
export const INTEGRATION_SECURITY_SPEC_TAG_LABEL = () => 'Tag';
export const INTEGRATION_SECURITY_SPEC_HMAC_ENABLED_LABEL = () => 'Enable HMAC';
export const INTEGRATION_SECURITY_SPEC_SECURE_SSL_LABEL = () => 'Secure SSL';

export const INTEGRATION_SECURITY_SPEC_HEADER_LABEL = () => `Security`;

export const AUTOFILL_SEQUENCE_PRODUCT_LABEL = () => 'Product';
export const AUTOFILL_SEQUENCE_OPERATION_LABEL = () => 'Operation';
export const AUTOFILL_SEQUENCE_OPERATION_TYPE_LABEL = () => 'Operation Type';
export const AUTOFILL_SEQUENCE_OPERATION_SEQUENCE_LABEL = () =>
	'Operation Sequence';
export const AUTOFILL_SEQUENCE_TABLE_ACTIONS_LABEL = () => 'Actions';
export const AUTOFILL_SEQUENCE_TABLE_CALL_SEQUENCE_LABEL = () =>
	'Call Sequence';
export const AUTOFILL_PLUGIN_LABEL = () => 'Data Autofill Plugin';

// INTEGRATIONS API
export const FETCH_INTEGRATIONS_ERROR = () => 'Failed to fetch integrations';
export const ADD_INTEGRATION_SUCCESS = () => 'Integration added successfully';
export const ADD_INTEGRATION_FAILURE = () => 'Failed to add integration';
export const EDIT_INTEGRATION_SUCCESS = () =>
	'Integration updated successfully';
export const EDIT_INTEGRATION_FAILURE = () => 'Failed to update integration';
export const DELETE_INTEGRATION_SUCCESS = () =>
	'Successfully deleted integration';
export const DELETE_INTEGRATION_FAILURE = () => 'Failed to delete integration';
export const ADD_AUTOFILL_SEQUENCE_SUCCESS = () =>
	'Autofill sequence added successfully';
export const ADD_AUTOFILL_SEQUENCE_FAILURE = () =>
	'Failed to add autofill sequence';
export const EDIT_AUTOFILL_SEQUENCE_SUCCESS = () =>
	'Autofill sequence updated successfully';
export const EDIT_AUTOFILL_SEQUENCE_FAILURE = () =>
	'Failed to update autofill sequence';
export const DELETE_AUTOFILL_SEQUENCE_SUCCESS = () =>
	'Autofill sequence deleted successfully';
export const DELETE_AUTOFILL_SEQUENCE_FAILURE = () =>
	'Failed to delete autofill sequence';
export const INTEGRATION_REQUIRED_FIELD_ERROR = () => 'This is required';
export const INTEGRATION_URL_FIELD_ERROR = () => 'Invalid URL';
export const INTEGRATION_NAME_EXISTS_FIELD_ERROR = () => 'Name already exists';
export const INTEGRATION_NAME_FORMAT_FIELD_ERROR = () => 'Invalid format';
export const INTEGRATION_HMAC_ENABLED_SECRET_MISSING_ERROR = () =>
	'When HMAC is enabled, you must include a secret.';
export const INTEGRATION_TAG_PRESENT_SECRET_MISSING_ERROR = () =>
	'A tag requires a secret';
export const INTEGRATION_SECRET_FORMAT_FIELD_ERROR = () =>
	'Must contain only alphanumeric characters and underscores, with a length between 32 and 64 characters.';
export const INTEGRATION_TAG_FORMAT_FIELD_ERROR = () =>
	'Must contain only alphanumeric characters and underscores, with a length between 2 and 32 characters.';

// ACTIONS FOR BUTTONS
export const ACTION_CANCEL = () => 'Cancel';
export const ACTION_CREATE = () => 'Create';
export const ACTION_SAVE = () => 'Save';
export const ACTION_DELETE = () => 'Delete';
export const ACTION_EDIT = () => 'Edit';

// WEBHOOKS
export const WEBHOOK_CONFIGURATION_LABEL = () => 'Webhook';
export const WEBHOOKS_CONFIGURED_LABEL = () => 'Webhooks Configured';
export const WEBHOOK_CONFIGURATION_MODAL_NAME_LABEL = () => 'Name';
export const WEBHOOK_CONFIGURATION_MODAL_DISPLAYNAME_LABEL = () =>
	'Display Name';
export const WEBHOOK_CONFIGURATION_MODAL_INTEGRATION_NAME_LABEL = () =>
	'Webhook';
export const WEBHOOK_CONFIGURATION_MODAL_EVENTS_LABEL = () => 'Events';
export const WEBHOOK_CONFIGURATION_MODAL_RETRY_STRATEGY_LABEL = () =>
	'Retry Strategy';
export const WEBHOOK_CONFIGURATION_MODAL_FAILURE_HANDLING_LABEL = () =>
	'Failure Handling';
export const WEBHOOK_CONFIGURATION_MODAL_FAILURE_STRATEGY_LABEL = () =>
	'Failure Handling Mode';
export const WEBHOOK_CONFIGURATION_MODAL_ACT_ON_TIMEOUT_LABEL = () =>
	'Act On Timeout';
export const WEBHOOK_CONFIGURATION_MODAL_FAILURE_STRATEGY_DISABLED_HELPER_TEXT =
	() => 'Failure handing mode is disabled when retry strategy is none';
export const WEBHOOK_CONFIGURATION_MODAL_ACT_ON_STATUS_CODE_LABEL = () =>
	'Act On Status Codes';
export const WEBHOOK_CONFIGURATION_MODAL_ALERT_INTEGRATION_NAME_LABEL = () =>
	'Alert Integration Name';
export const WEBHOOK_CONFIGURATION_MODAL_RESET_FAILURE_INTEGRATION_LABEL = () =>
	'Reset Failure Integration';
export const WEBHOOK_CONFIGURATION_MODAL_ENABLED_LABEL = () => 'Enabled';
export const WEBHOOK_CONFIGURATION_ADDED_SUCCESS = () =>
	'Webhook Configuration added successfully';
export const WEBHOOK_CONFIGURATION_ADDED_FAILURE = () =>
	'Failed to add Webhook Configuration';
export const WEBHOOK_CONFIGURATION_EDITED_SUCCESS = () =>
	'Webhook Configuration edited successfully';
export const WEBHOOK_CONFIGURATION_EDITED_FAILURE = () =>
	'Failed to edit Webhook Configuration';
export const WEBHOOK_CONFIGURATION_MODAL_REQUIRED_MESSAGE = () =>
	'This is required';
export const WEBHOOKS_CONFIGURATIONS_TABLE_NAME_HEADER_LABEL = () => 'Name';
export const WEBHOOKS_CONFIGURATIONS_TABLE_INTEGRATION_HEADER_LABEL = () =>
	'Integration';
export const WEBHOOKS_CONFIGURATIONS_TABLE_SUSPENDED_HEADER_LABEL = () =>
	'Suspended';
export const WEBHOOKS_CONFIGURATIONS_TABLE_STATUS_HEADER_LABEL = () => 'Status';
export const WEBHOOKS_CONFIGURATIONS_TABLE_STATUS_ACTIONS_LABEL = () =>
	'Actions';
export const WEBHOOKS_CONFIGURATIONS_TABLE_STATUS_ENABLED = () => 'Enabled';
export const WEBHOOKS_CONFIGURATIONS_TABLE_COLLAPSE_EVENTS_HEADER = (
	totalEvent: number,
) => `Events (${totalEvent})`;
export const WEBHOOKS_CONFIGURATIONS_TABLE_COLLAPSE_RETRY_STRATEGY_HEADER =
	() => 'Retry Strategy';
export const WEBHOOKS_CONFIGURATIONS_TABLE_COLLAPSE_ACT_ON_STATUS_HEADER = () =>
	'Act On Status';
export const WEBHOOKS_CONFIGURATIONS_TABLE_COLLAPSE_FAILURE_MODE_HEADER = () =>
	'Failure Handling Mode';
export const WEBHOOKS_CONFIGURATIONS_TABLE_COLLAPSE_ACT_ON_TIMEOUT_HEADER =
	() => 'Act On Timeout';
export const WEBHOOKS_CONFIGURATIONS_TABLE_COLLAPSE_RESET_FAILURE_HEADER = () =>
	'Reset Failure Integration';
export const WEBHOOKS_CONFIGURATIONS_TABLE_COLLAPSE_ALERT_INTEGRATION_HEADER =
	() => 'Alert Integration Name';
export const CONFIRM_DELETE_WEBHOOK_CONFIGURATION_MODAL_HEADER_LABEL = () =>
	'Delete Webhook Configuration?';
export const CONFIRM_DELETE_WEBHOOK_CONFIGURATION_MODAL_CONFIRM_MESSAGE = (
	name: string,
) => `Are you sure you want to delete ${name}? This action cannot be undone.`;
export const CONFIRM_DELETE_WEBHOOK_CONFIGURATION_MODAL_CANCEL_TEXT = () =>
	'No, Cancel';
export const CONFIRM_DELETE_WEBHOOK_CONFIGURATION_MODAL_DELETE_TEXT = () =>
	'Yes, Delete';
export const CONFIRM_UNSUSPEND_WEBHOOK_CONFIGURATION_MODAL_HEADER_LABEL = () =>
	'Unsuspend Webhook Configuration?';
export const CONFIRM_UNSUSPEND_WEBHOOK_CONFIGURATION_MODAL_CONFIRM_MESSAGE = (
	name: string,
) =>
	`Are you sure you want to unsuspend ${name}? This action cannot be undone.`;
export const CONFIRM_UNSUSPEND_WEBHOOK_CONFIGURATION_MODAL_CANCEL_TEXT = () =>
	'No, Cancel';
export const CONFIRM_UNSUSPEND_WEBHOOK_CONFIGURATION_MODAL_DELETE_TEXT = () =>
	'Yes, Unsuspend';
export const CONFIRM_UNSUSPEND_WEBHOOK_CONFIGURATION_MODAL_SUSPENDED_ON = (
	timestamp: string,
) => `Suspended on: ${timestamp}`;
export const WEBHOOK_CONFIGURATION_UNSUSPEND_DATE_FORMAT = () =>
	'ddd, MMM D, YYYY h:mm A';
export const DELETE_WEBHOOK_CONFIGURATION_SUCCESS = () =>
	'Webhook Configuration deleted successfully';
export const DELETE_WEBHOOK_CONFIGURATION_FAILURE = () =>
	'Failed to delete Webhook Configuration';
export const UNSUSPEND_WEBHOOK_CONFIGURATION_SUCCESS = () =>
	'Webhook Configuration unsuspended successfully';
export const UNSUSPEND_WEBHOOK_CONFIGURATION_FAILURE = () =>
	'Failed to unsuspend Webhook Configuration';

// GENERAL/MISC
export const CREATE_FIRST_TITLE = (itemType: () => string) =>
	`Create ${itemType()} First`;
export const CREATE_FIRST_DESCRIPTION = (
	integrationType: (plural: boolean) => string,
	itemType: () => string,
) =>
	`There are no ${integrationType(
		true,
	)}. Create one first before creating a new ${itemType()}.`;
export const UNEDITABLE_FIELD_INFO = () => 'This cannot be changed';
export const SPACES_NOT_ALLOWED_ERROR_MSG = () => 'Spaces not allowed';
export const IS_TAKEN_ERROR_MSG = (fieldName: string) =>
	`${fieldName} is taken`;
export const EMPTY_ERROR_MSG = () => 'This cannot be blank';
export const INVALID_FAILURE_WEBHOOK_MSG = () =>
	'Cannot use same webhook integration';
export const WEBHOOK_INTEGRATION_ERR_MSG = () =>
	'Cannot be the same integration as Webhook';
export const WEBHOOK_ACT_ON_STATUS_MSG = () =>
	'By default, all 4xx and 5xx status codes will be acted on';
export const INVALID_FORMAT_ERROR_MSG = () => 'Invalid format';
export const DISPLAYNAME_INVALID_FORMAT = () =>
	'Invalid format. Valid characters are A-Z a-z 0-9 _ - ! * . ( ) ~ ';
export const CLOSE_TEXT = () => 'Close';

// ROLES
export const ROLES_SUBHEADER_TABLE_NAME = () => 'Role Name';
export const ROLES_SUBHEADER_EFFECTIVE_DATE = () => 'Effective Date';
export const ROLES_HEADER = () => 'Roles';
export const ROLES_ADD_ROLE_HEADER = () => 'Add Role';
export const ROLE_FORM_NAME_FIELD_LABEL = () => 'Role Name';
export const ROLE_FORM_DISPLAY_NAME_FIELD_LABEL = () => 'Display Name';
export const ROLE_FORM_UI_PERMISSION_TOGGLE_LABEL = () => 'UI Permissions';
export const ROLE_FORM_UI_PERMISSION_INFO_LABEL = () =>
	'Adds fetch permissions for Ontology, Product, Tenant, and Workflow which are the minimum set of permissions required to use Core UI.';
export const ROLE_BREADCRUMB_HOME = () => 'Roles';
export const ROLE_BREADCRUMB_ADD = () => 'Add Role';
export const ROLE_FORM_PERMISSIONS_FIELD_LABEL = () => 'Permissions';
export const ROLE_FORM_FILTER_INPUT_LABEL = () => 'Filter Permissions';
export const ROLE_FORM_ADD_ROLE_TITLE = () => 'New Role';
export const ROLE_FORM_UPDATE_ROLE_TITLE = () => 'Update Role';
export const ROLE_FORM_FILTER_SELECT_VISIBLE_BUTTON = () => 'Select Visible';
export const ROLE_FORM_FILTER_CLEAR_VISIBLE_BUTTON = () => 'Clear Visible';
export const ROLE_FORM_FILTER_SAVE_BUTTON = () => 'Save';
export const ROLE_FORM_NOT_FOUND = () => 'Role not found';

export const ROLES_ACTIONS_EDIT_TOOLTIP_TEXT = () => 'Edit role';
export const ROLES_ACTIONS_DELETE_TOOLTIP_TEXT = () => 'Delete role';

export const ROLES_CONFIRM_DELETE_MODAL_HEADER = () => 'Delete Role';
export const ROLES_CONFIRM_DELETE_MODAL_MESSAGE = (roleName: string) =>
	`Are you sure you want to delete the role "${roleName}"?`;
export const ROLES_CONFIRM_DELETE_MODAL_CANCEL_BUTTON = () => 'Cancel';
export const ROLES_CONFIRM_DELETE_MODAL_DELETE_BUTTON = () => 'Delete';

export const ROLES_TOAST_DELETE_SUCCESS = () => 'Role deleted successfully';
export const ROLES_TOAST_DELETE_FAILURE = () => 'Failed to delete role';
export const ROLES_TOAST_ADD_SUCCESS = () => 'Role added successfully';
export const ROLES_TOAST_ADD_FAILURE = () => 'Failed to add role';
export const ROLES_TOAST_UPDATE_SUCCESS = () => 'Role updated successfully';
export const ROLES_TOAST_UPDATE_FAILURE = () => 'Failed to update role';
